import React, { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import Modal from "../../UIComponents/CustomModal/Modal";

const MicrosoftLoginModal = (props) => {
    const inputRef = useRef();

    useEffect(() => {
        inputRef.current.focus();
    }, []);

    const handleNext = () => {
        let domainVal = inputRef.current?.value ? inputRef.current.value : null;

        // console.log(inputRef.current.value);
        if (domainVal) window.location.href = `https://api2.radarr.com/azure/sso/${domainVal}`;
        else toast.error("Please enter a valid domain");
    };
    const handleEnterKey = (e) => {
        if (e.key === "Enter") handleNext();
    };
    return (
        <>
            <Modal className="microsoft__popup" show={props.open} onClose={props.closeModal}>
                <Modal.Header>Microsoft Login</Modal.Header>
                <Modal.Content>
                    <div className="microsoft__main__content">
                        <p className="login-form-label">Please add your company domain</p>
                        <input
                            ref={inputRef}
                            onKeyPress={(e) => handleEnterKey(e)}
                            type="text"
                            placeholder="Enter the domain name"
                            className="login-form-input"
                        />
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton normal onClick={props.closeModal}>
                        Cancel
                    </Modal.ActionButton>
                    <Modal.ActionButton filled onClick={handleNext}>
                        Next
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        </>
    );
};

export default MicrosoftLoginModal;
